import React from 'react';

const NotFound = () => {
    return (
        <div className="alert alert-danger text-center p-5">
            <h2>Page not found</h2>
            <h3>404 Error!!!</h3>
        </div>
    );
};

export default NotFound;